import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container d-flex position-relative custom-background-height py-5"
}
const _hoisted_2 = { class: "col-12 col-md-10 col-lg-9 mx-auto" }
const _hoisted_3 = { class: "text-primary fw-normal px-4 mb-5" }
const _hoisted_4 = { class: "w-100 p-4 rounded-4 shadow bg-light" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-md-8 col-lg-9 text-secondary mb-5" }
const _hoisted_7 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["data-bs-results", "data-bs-projectId"]
const _hoisted_10 = { class: "row align-items-center mt-4 mb-3 border border-3 border-top-0 border-start-0 border-end-0 pb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-primary fw-normal col-12 col-xxl-2" }, "Results:", -1)

import { useRoute } from "vue-router";
import { impalaApi } from "@/main.ts";
import { onBeforeMount, ref } from "vue";
import SendMailModal from "@/components/modals/SendMailModal.vue";
import ProjectFilters from "@/components/projects/show/ProjectFilters.vue";
import ProjectResultTable from "@/components/projects/show/ProjectResultTable.vue";
import ProjectInformations from "@/components/projects/show/ProjectInformations.vue";
import { useClientStore } from "@/store/ClientStore";
import { storeToRefs } from "pinia";


const __default__ = {
  name: "Project",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const client = ref({});
const results = ref<Array<string>>([]);
const projectResults = ref([]);
const resultsArray = ref([]);
const clientStore = useClientStore();
const { pageLoading } = storeToRefs(clientStore);
const route = useRoute();

onBeforeMount(async () => {
  pageLoading.value = true;

  projectResults.value = await fetchData(
    `/client-dashboard/projects/${route.params.projectId}/results`
  );
  resultsArray.value = projectResults.value.results;
  filteredResults.value = resultsArray.value;
  client.value = await fetchData(
    `/admin/clients/${projectResults.value.project.clientId}`
  );
  pageLoading.value = false;
});

const fetchData = async (url: string) => {
  try {
    const response = await impalaApi.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const onChangeSelectedResults = (newResults: Array<string>) => {
  results.value = newResults;
};

function checkAgeInterval(age, interval) {
  switch (interval) {
    case "< 18":
      return age < 18;
    case "18 - 24":
      return age >= 18 && age <= 24;
    case "25 - 34":
      return age >= 25 && age <= 34;
    case "35 - 44":
      return age >= 35 && age <= 44;
    case "> 45":
      return age >= 45;
    default:
      return true;
  }
}

const filteredResults = ref();

const onFilter = (filters: never) => {
  filteredResults.value = resultsArray.value;

  const filterFunctions = Object.keys(filters).map((field) => {
    return (result) => {
      const value = result.metadata.respondentInfo?.[field];
      const filterValue = filters[field];
      return (
        !filterValue ||
        (Array.isArray(value)
          ? value.includes(filterValue)
          : value === filterValue) ||
        (field === "0" && checkAgeInterval(value, filterValue))
      );
    };
  });

  filteredResults.value = filteredResults.value.filter((result) => {
    return filterFunctions.every((filterFunction) => filterFunction(result));
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (projectResults.value.project)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(projectResults.value.project.projectName), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(ProjectInformations, {
                    clientName: client.value.name,
                    projectName: projectResults.value.project.projectName,
                    description: projectResults.value.project.description,
                    currentRespondentsCount: 
                projectResults.value.project.currentRespondentsCount
              ,
                    maxAllowedRespondents: 
                projectResults.value.project.maxAllowedRespondents
              ,
                    services: projectResults.value.project.services
                  }, null, 8, ["clientName", "projectName", "description", "currentRespondentsCount", "maxAllowedRespondents", "services"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    href: projectResults.value.project.surveyPageUrl,
                    target: "_blank",
                    class: "btn btn-info text-light rounded-pill text-secondary col-12 col-sm-5 col-md-12 mb-4 mb-sm-0 mb-md-4"
                  }, " Preview Stimuli ", 8, _hoisted_8),
                  _createElementVNode("div", {
                    class: "btn btn-primary text-light rounded-pill col-12 col-sm-5 offset-sm-1 offset-md-0 col-md-12",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#sendMailModal",
                    "data-bs-title": "Send results to mail",
                    "data-bs-results": JSON.stringify(results.value),
                    "data-bs-projectId": _unref(route).params.projectId
                  }, " Get Summary Results ", 8, _hoisted_9)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(ProjectFilters, {
                  onFilter: onFilter,
                  segmentations: projectResults.value.project.segmentations
                }, null, 8, ["segmentations"])
              ]),
              _createVNode(ProjectResultTable, {
                onChangeSelectedResults: onChangeSelectedResults,
                tableData: filteredResults.value,
                segmentations: projectResults.value.project.segmentations
              }, null, 8, ["tableData", "segmentations"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(SendMailModal)
  ], 64))
}
}

})